<script>
import AddHrDialog from '@components/dialogs/safehaven/add-hr-dialog.vue'
import ComingSoonTooltip from '@components/tooltips/coming-soon-tooltip.vue'
export default {
  components: {
    AddHrDialog,
    ComingSoonTooltip,
  },
  props: {
    carddata: { type: Object, required: true },
  },
  data() {
    return {
      userOrg: '',
      addDialog: false,
      edit: false,
      create: false,
      resourceMenuItem: null,
      resourceItem: null,
    }
  },
  computed: {
    getPadding() {
      if (this.carddata.key === 'health-check') {
        return 'pl-0 pr-0 pr-md-3 py-3'
      } else if (this.carddata.key === 'health-record') {
        return 'px-0 px-md-2 py-3'
      }
      return 'pl-0 pl-md-3 pr-0 py-3'
    },
  },
  watch: {
    addDialog: function (oldValue, newValue) {
      if (this.addDialog) this.$emit('add-record')
    },
  },
  async mounted() {
    // Get User Data
    const userData = JSON.parse(localStorage.getItem('auth.currentUser'))
    this.userOrg = userData.user.user_org_details[0].org_name
  },
  methods: {
    clickHandler() {
      this.$emit('add-record')
      if (this.carddata.key === 'health-check') this.$emit('symptom-checker')
      else if (this.carddata.key === 'document-center') {
        this.$emit('document-center')
      }
    },
    editItem({ item, plainResource }) {
      const menuItem = this.getMenuItemFromPlainResource(plainResource)
      // Give as a prop to add-hr-dialog the menuItem
      this.resourceMenuItem = menuItem
      // Give as a prop item
      this.resourceItem = item
      // Open dialog
      this.edit = true
      this.addDialog = true
    },
    getMenuItemFromPlainResource(plainResource) {
      for (const key in this.menuItems) {
        if (this.menuItems[key].plain_resource === plainResource) {
          return this.menuItems[key]
        }
      }
      return null
    },
    itemSelected(item) {
      this.resourceMenuItem = item
      this.create = true
      this.addDialog = true
    },
  },
}
</script>

<template>
  <v-col cols="12" xl="4" lg="4" md="4" sm="12" xs="12" class="pa-0">
    <div :class="getPadding">
      <ComingSoonTooltip v-if="!carddata.is_active" top>
        <div :class="$style.cardStyle" outlined>
          <div class="d-flex align-center">
            <v-img
              height="28"
              contain
              :src="carddata.src"
              class="flex-grow-0 mr-2"
            ></v-img>
            <span class="flex-grow-1">{{ carddata.title }}</span>
          </div>
          <div :class="$style.cardDescDiv">
            <p :class="$style.cardDesc">{{ carddata.desc }}</p>
          </div>

          <a disable="inactive">
            {{ carddata.linkText }}
          </a>
        </div>
      </ComingSoonTooltip>
      <div v-else :class="$style.cardStyle" outlined>
        <div class="d-flex align-center">
          <v-img
            height="28"
            contain
            :src="carddata.src"
            class="flex-grow-0 mr-2"
          ></v-img>
          <span class="flex-grow-1">{{ carddata.title }}</span>
        </div>
        <div :class="$style.cardDescDiv">
          <p :class="$style.cardDesc">{{ carddata.desc }}</p>
        </div>

        <a v-if="carddata.key !== 'health-record'" @click="clickHandler">
          {{ carddata.linkText }}
        </a>
        <AddHrDialog
          v-else
          avatar-button
          :dialog.sync="addDialog"
          :group="0"
          :edit.sync="edit"
          :create.sync="create"
          :menu.sync="resourceMenuItem"
          :item.sync="resourceItem"
          :btn-type="false"
          @add-sc="symptomChecker = !symptomChecker"
          @form-saved="reloadTimeline = !reloadTimeline"
          @delete-from-hr="reloadTimeline = !reloadTimeline"
        ></AddHrDialog>
      </div>
    </div>
  </v-col>
</template>

<style lang="scss" module>
@import '@design';
.cardStyle {
  padding: 30px !important;
  text-align: left;
  background: #fff;
  border: 1px solid #93c0e8;
  border-radius: 4px !important;
  box-shadow: 0 0 6px rgba(146, 191, 231, 0.6);
}
.cardStyle p {
  margin-bottom: 0 !important;
}

.cardBackground {
  background: #fff;
}

.cardDescDiv {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 140px;
}

.cardDesc {
  padding-top: 10px;
  padding-bottom: 10px !important;
  font-size: 14px;
  text-align: left;
  vertical-align: middle;
}
.btnStyle {
  font-size: 14px !important;
}

@media screen and (max-width: 1861px) {
  .cardStyle p {
    min-height: 120px;
  }
}
@media screen and (max-width: 1600px) {
  .cardStyle {
    padding: 30px 20px !important;
  }
  .cardStyle p {
    width: 100%;
    margin: 16px auto;
  }
}

@media screen and (max-width: 959px) {
  .cardStyle {
    padding: 30px !important;
  }
}
@media screen and (max-width: 479px) {
  .cardStyle {
    padding: 30px !important;
  }
}
</style>
